/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import type { IntegrationType } from 'embercom/objects/standalone/constants';

export default class Integration extends Model {
  @attr('number') integrationType!: IntegrationType;
  @attr('number') integrationId!: number | null;
  @attr('number') integrationState!: number;
  @attr('string') displayName!: string;
  @attr('string') externalIdentifier!: string;
  @attr('array') supportsExternalTicketHandoverFromChannels!: Array<string>;
  @attr('array') supportsExternalAgentHandoverFromChannels!: Array<string>;
  @attr('boolean') productionIntegration!: boolean;
  @attr('boolean') defaultIntegration!: boolean;
}
